import axios from "axios";
import API from "../_helpers/endpointService";

export const getprojectyardauditdocinfo = (data, id) => {
  let apiUrl = API.YARD_AUDITREPORT + id + '?Name=' + data.Name + '&Top=' +data.Top + '&PageNo=' + data.PageNo + '&PageSize=' + data.PageSize
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "YARD_AUDITREPORTS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const addyardauditdocumentinfo = (data, id, modify) => {
  let apiUrl = API.YARD_AUDITREPORT + id + '?modify=' + modify
  return (dispatch) => {
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
     
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({type:"REPORT_DOCS",data:[]});
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const deletemulitiyardauditdocs = (data,id) => {
  let ids = "";
  if(data && data.length > 0){
       data.map((val, index) => {
          if ( index == 0){
          ids += "ids=" + val.data;
          }
          else
          {
          ids += "&ids=" + val.data;
          }
      })
  } 
  let apiUrl = API.YARD_AUDITREPORT + 'ids?' + ids ;
  return (dispatch) => {
    axios({
      method: "delete",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadsingleyardauditdocs = (data) => {
  let apiUrl = API.YARD_AUDITREPORT + data.DocumentId + '/Download';
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
    })
      .then((response) => {
       dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = data.DocumentName;
          a.click();
        } else {
        }
      })
      .catch((error) => {
      dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const downloadmultipleyardauditdocs = (data) => {
  let keys = "";
  if(data && data.length > 0){
       data.map((val, index) => {
          if ( index == 0){
          keys += "keys=" + val.objectkey;
          }
          else
          {
          keys += "&keys=" + val.objectkey;
          }
      })
  }
  let apiUrl = API.YARD_AUDITREPORT  + 'keys?' + keys;
  return (dispatch) => {
    axios({
      method: "get",
      url: apiUrl,
      responseType: "blob",
    })
      .then((response) => {
        if (response?.status === 200) {
          let blob = new Blob([response.data]);
          let url = URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = "YardAuditReport.zip"
          a.click();
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};

export const gethistorylogyardauditdocinfo = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=YardAuditReport'
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};